import React from 'react';
import { AwardIcon, CheckCircleIcon } from 'lucide-react';
export const ExpertPanel = () => {
  const experts = [{
    name: 'Dr. Grace Holland, MD, FACOG',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wVLKgod3DUngKaLDgptxnJ/z0yfjbMtizCg7mAUjjxGb.jpg',
    credentials: 'Chief Medical Officer, Harvard Medical School Affiliate',
    specialty: 'Vaginal Health & Microbiome',
    experience: 'Lead researcher on 17 clinical trials examining biofilm disruption'
  }, {
    name: 'Dr. Elizabeth Chen, MD, FACOG',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    credentials: 'Director of Menopause Medicine, Harvard Medical School',
    specialty: 'Hormone Therapy Specialist',
    experience: '25+ years researching estrogen receptor modulators'
  }, {
    name: 'Dr. Sarah Johnson, MD, PhD',
    image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80',
    credentials: "Senior Consultant, Mayo Clinic Women's Health",
    specialty: 'Reproductive Endocrinology',
    experience: 'Published 47 peer-reviewed studies on perimenopause'
  }, {
    name: 'Dr. Kaitlyn Conner, MD, MPH',
    image: 'https://images.unsplash.com/photo-1651008376811-b90baee60c1f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80',
    credentials: "Research Director, Stanford Women's Health",
    specialty: 'Bacterial Biofilm Research',
    experience: 'Principal investigator on 8 NIH-funded studies'
  }];
  return <section className="my-8 sm:my-12" data-id="element-2355">
      <h2 className="text-xl sm:text-2xl font-serif font-bold text-slate-900 mt-6 sm:mt-10 mb-4 sm:mb-5 leading-tight border-b border-slate-200 pb-2 flex items-center" data-id="element-2356">
        <AwardIcon className="h-5 w-5 text-slate-700 mr-2 inline flex-shrink-0" data-id="element-2357" />
        <span data-id="element-2358">Our Medical Review Board: 120+ Years Combined Experience</span>
      </h2>
      <p className="text-base text-slate-800 leading-relaxed mb-6" data-id="element-2359">
        Every solution we develop is reviewed and validated by our medical
        advisory board, comprised of leading OB/GYNs, researchers, and women's
        health specialists from prestigious institutions. With a combined{' '}
        <span className="font-semibold text-slate-900 bg-yellow-100 px-1" data-id="element-2360">
          120+ years of clinical experience
        </span>{' '}
        and over 200 published research papers, our board ensures every
        recommendation is evidence-based and clinically sound.
      </p>
      {/* Lead Expert Quote */}
      <blockquote className="italic pl-4 py-4 my-6 text-slate-700 leading-relaxed border-l-4 border-slate-400 bg-slate-50 text-sm sm:text-base" data-id="element-2361">
        <p data-id="element-2362">
          "Our mission is to transform women's health by developing solutions
          based on rigorous science, not marketing hype. Every protocol we
          recommend has been tested in clinical settings and proven effective by
          objective measures."
        </p>
        <p className="mt-3 font-medium not-italic" data-id="element-2363">
          — Dr. Grace Holland, MD, FACOG, Chief Medical Officer
        </p>
      </blockquote>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-6 sm:mt-8" data-id="element-2364">
        {experts.map((expert, index) => <div key={index} className="border border-slate-200 p-3 sm:p-4 rounded-lg flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-2365">
            <img src={expert.image} alt={expert.name} className="w-16 h-16 sm:w-24 sm:h-24 rounded-full object-cover border-2 border-slate-300 mx-auto sm:mx-0" data-id="element-2366" />
            <div data-id="element-2367">
              <div className="flex items-center justify-center sm:justify-start" data-id="element-2368">
                <h3 className="font-serif font-semibold text-slate-900 text-base sm:text-lg text-center sm:text-left" data-id="element-2369">
                  {expert.name}
                </h3>
                <CheckCircleIcon className="h-4 w-4 text-blue-600 ml-2" title="Verified Medical Expert" data-id="element-2370" />
              </div>
              <p className="text-slate-700 font-medium text-sm text-center sm:text-left" data-id="element-2371">
                {expert.credentials}
              </p>
              <p className="text-slate-600 text-sm mt-1 text-center sm:text-left" data-id="element-2372">
                <span className="font-medium" data-id="element-2373">Specialty:</span>{' '}
                {expert.specialty}
              </p>
              <p className="text-slate-600 text-sm mt-1 text-center sm:text-left" data-id="element-2374">
                {expert.experience}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
};